import type { ChecklistExport } from '../../lib/regulations/checklist'
import { jsPDF } from 'jspdf'

export function renderChecklistPdf(exported: ChecklistExport): Blob {
  const doc = new jsPDF({ unit: 'mm', format: 'a4' })
  const margin = 16
  const width = 210 - margin * 2
  let y = 20

  const ensure = (need: number) => {
    if (y + need <= 280) return
    doc.addPage()
    y = 20
  }

  const write = (text: string, size = 11, gap = 6) => {
    doc.setFontSize(size)
    const lines = doc.splitTextToSize(text, width) as string[]
    for (const line of lines) {
      ensure(6)
      doc.text(line, margin, y)
      y += gap
    }
  }

  doc.setTextColor(11, 110, 79)
  write(exported.title, 16, 8)
  doc.setTextColor(31, 41, 55)
  write(exported.generatedLabel, 10, 5)
  write(exported.disclaimer, 10, 5)
  write(exported.profileNote, 10, 8)

  if (!exported.items.length) write('No checklist items were selected.')

  exported.items.forEach((item, index) => {
    ensure(24)
    doc.setTextColor(11, 110, 79)
    write(`${index + 1}. ${item.title}`, 12, 6)
    doc.setTextColor(31, 41, 55)
    write(`Applicability: ${item.applicability}`, 10, 5)
    write(`Why it may be relevant: ${item.why}`, 10, 5)
    write(`Suggested action: ${item.action}`, 10, 5)
    write(`Suggested owner: ${item.owner}`, 10, 5)
    write(`Deadline: ${item.deadline}`, 10, 5)
    write(`Source: ${item.source}`, 10, 5)
    write(`Verification needed: ${item.verification}`, 10, 8)
  })

  return doc.output('blob')
}
